@if (appUpdateService.updateAvailable) {
  <app-update />
}

<w3w-map [w3w_api_key]="w3w_api_key" [map_api_key]="map_api_key" />
<div class="min-h-full" [class]="appStorage.themeMode === 'dark' ? 'dark bg-dark-bg-view' : 'light bg-gray-50'">
  <router-outlet />

  @if (connectedDevicesService.overlay_connectedDevices) {
    <connected-devices-overlay />
  }

  <universal-search-overlay />
</div>
